import { render, staticRenderFns } from "./CompMenu.vue?vue&type=template&id=0c7383f8&"
import script from "./CompMenu.vue?vue&type=script&lang=js&"
export * from "./CompMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports